import type { FaireProductEntity } from "../../entity_types/product";

export const p_6mefxkxphy: FaireProductEntity = {
  token: "p_6mefxkxphy",
  type: "product",
  name: "Lymphatic Massage Cream",
  brandToken: "b_3bx0gt904o",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/1c083652d78151f3aed305a6f1230da9b3f41ae48784a76523074a8b7e3d56c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a0649df795480f8119354c1464a99a2f178630bd5d1476b6d31f4698337955b.jpeg",
    "https://cdn.faire.com/fastly/434f515578473efeb9fca43a1128039745ff70f836c23984d4d318fe59454dde.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "🚨 New Product Release 🚨\n\nLymphatic Drainage Massage Cream is the ultimate aid to help the body flush toxins out. Perfect for children and adults alike, this product gives the perfect amount of slickness, while absorbing fully into the skin when your massage is over.\n\nKeeping your lymphatic system flowing is the key to a healthy body. Stimulate lymph fluid drainage so your immune and circulatory systems can stay strong, keeping sickness at bay. This is the perfect fall & winter product to have on hand! 🍂\n\nWe use an essential oil blend that is great for flushing toxins out, and it smells lovely as well. The lasting scent is an added benefit of this amazing cream. This product also works for back, foot & neck rubs. Use twice weekly to keep the lymohatic system flowing well, or daily to give it a boost. Can be used every two hours when sick or feeling like you're coming down with a cold. \n\n",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:32.589Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
